import React from "react";

function Summary({ cartItems, cartSummary }) {
  const subtotal = Number(cartSummary.subtotal || 0);
  const total = Number(cartSummary.total || 0);
  const discount = Number(cartSummary.discount || 0);
  const shipping = Number(cartSummary.shipping || 0);

  const totalWithoutDiscount = cartItems.reduce((sum, item) => {
    return sum + item.mrp * item.quantity;
  }, 0);

  const totalSaving = (totalWithoutDiscount || 0) - (cartSummary.total || 0);

  return (
    <>
      {totalWithoutDiscount && (
        <div className="summary-row">
          <span>Subtotal (without Discount)</span>
          <span className="text-decoration-line-through">₹ {totalWithoutDiscount.toLocaleString()}</span>
        </div>
      )}

      <div className="summary-row">
        <span>Subtotal</span>
        <span>₹ {subtotal.toLocaleString()}</span>
      </div>
      <div className="summary-row">
        <span>Shipping</span>
        <span className={shipping === 0 ? "text-white" : ""}>
          {shipping === 0 ? "Complimentary" : `₹ ${shipping}`}
        </span>
      </div>
      
      {discount > 0 && (
        <div className="summary-row">
          <span>Coupon Discount:</span>
          <span>-₹{discount.toFixed(2)}</span>
        </div>
      )}

      <div className="summary-total">
        <span>Total</span>
        <span>₹ {total.toLocaleString()}</span>
      </div>

      {totalSaving > 0 && (
        <div className="summary-total">
          You saved ₹{totalSaving.toFixed(2)} on this order!
        </div>
      )}
    </>
  );
}

export default Summary;
